'use client'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'

const DetailAccordion = ({ sections }) => {
  const safeSections = Array.isArray(sections) ? sections : []
  if (safeSections.length === 0) return null

  return (
    <div className="tw:border tw:border-gray-200 tw:rounded-xl">
      {safeSections.map((section, index) => {
        const title = section?.title || `Section ${index + 1}`
        const contentHtml = section?.content || ''

        return (
          <Accordion key={index} disableGutters defaultExpanded={false}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`detail-section-${index}-content`}
              id={`detail-section-${index}-header`}
              className="tw:px-2"
            >
              <h3 className="tw:text-lg tw:font-semibold">{title}</h3>
            </AccordionSummary>
            <AccordionDetails className="tw:pt-0">
              <div
                className="wp-content tw:text-sm tw:text-gray-600"
                dangerouslySetInnerHTML={{ __html: contentHtml }}
              />
            </AccordionDetails>
          </Accordion>
        )
      })}
    </div>
  )
}

export default DetailAccordion
